/**
 * Table unique « écran de l'app → aide disponible ».
 *
 * Avant, chaque page redéclarait son propre tableau emmaMuxIds : neuf pages
 * couvertes sur une quarantaine de routes, et aucune vidéo en anglais, donc
 * aucune icône d'aide pour un compte anglophone. Ici tout est au même endroit
 * et le bouton d'aide existe sur toutes les routes, vidéo ou pas.
 *
 *   video    : identifiants Mux par langue du compte (null = pas de vidéo).
 *   articles : clés d'articles du centre d'aide — stables entre les langues,
 *              c'est l'index.json qui les résout en titre et URL localisés.
 */

const VIDEOS = {
  home: {
    fr_BE: 'i9z1svKhIQdp11CuXt9fu9XLzEdl01gxiFHuwvmbRVJo',
    nl_BE: '94LcZ6zveMesGerC6e004mODzM902E1LvlYLo3yxByBlA',
    en_US: null
  },
  cart: {
    fr_BE: 'Qt2eUlFg3bPmGcC0200g3Bj02Qo802vwK00jm00okwA2oMq4E',
    nl_BE: 'ugIhDcp8BL7Bl8dwM74irCklJZ8CGookLEl01ZVEk3L8',
    en_US: null
  },
  checkout: {
    fr_BE: 'SzSKvsS1mxuALTsX1uUKBOE00nE73Gc11h4F02X7hZdhw',
    nl_BE: 'GnexuVj6oDqmZdooa22btQPx4Rn902P01pMET1d7xxpps',
    en_US: null
  },
  orders: {
    fr_BE: 'pNht01L7FgFQUoF3U6wpCZL5EmFeVF5eqToKOvexCZ004',
    nl_BE: 'NK3tC82yja01ecpbTS00ZqgyMlsRFbqD34d53799NRP02E',
    en_US: null
  },
  institute: {
    fr_BE: 'eIzqKn7GBdffbaCbelYFlwe8IHxcE02x8Ibd02GkuuC8M',
    nl_BE: '40000p4DpJN02CUh9p8gTLZoFdKt6kCqKaEbhbuy022X14M',
    en_US: null
  },
  marketing: {
    fr_BE: 'koIy8PtR02GmoCMiQbCLOdCZ759wnBgODCgdtbvbCpsw',
    nl_BE: 'lnv5O01Gu02AMyLjYfhOmk4U1tJFQq00Ds8dcEQtyPfUmA',
    en_US: null
  },
  academy: {
    fr_BE: 'TOgey5nz01A48NvZ2bwOkUNRBdEkwnLGIUqHGKENi9cE',
    nl_BE: 'rZbGDQaHQzn01Ee01J7GM2o8ShI100zH3yMvLWfIy018Zn00',
    en_US: null
  },
  sav: {
    fr_BE: 'pZ2vNyU2R9lkwHqjUhkcyb492TkMNx1V9bWpB2OYyJ00',
    nl_BE: 'qbfOTh433FvY9MtbJE00F3Dz5c44002yoKn9hfqzhP6I8',
    en_US: null
  }
};

/** Route (nom, tel que déclaré dans le router) → aide de cet écran. */
const HELP_MAP = {
  home: { video: VIDEOS.home, articles: ['tour-de-lapplication', 'passer-une-commande'] },

  // Panier et recherche produits : tout mène au même parcours de commande.
  cart: { video: VIDEOS.cart, articles: ['passer-une-commande'] },
  promocart: { video: VIDEOS.cart, articles: ['passer-une-commande'] },
  addcart: { video: VIDEOS.cart, articles: ['passer-une-commande'] },
  search: { video: VIDEOS.cart, articles: ['passer-une-commande'] },
  searchandadd: { video: VIDEOS.cart, articles: ['passer-une-commande'] },
  checkout: { video: VIDEOS.checkout, articles: ['passer-une-commande', 'mes-coordonnees'] },

  orders: { video: VIDEOS.orders, articles: ['suivre-ses-commandes', 'factures-et-documents'] },
  quote: { video: VIDEOS.orders, articles: ['suivre-ses-commandes'] },
  paid: { video: VIDEOS.orders, articles: ['suivre-ses-commandes'] },
  invpaid: { video: VIDEOS.orders, articles: ['factures-et-documents'] },

  institute: {
    video: VIDEOS.institute,
    articles: ['acceder-a-saloncare', 'saloncare-fiche-institut', 'saloncare-services']
  },
  myr_customer: { video: null, articles: ['saloncare-routine-plus'] },
  myr_customer_new: { video: null, articles: ['saloncare-routine-plus'] },

  marketing: { video: VIDEOS.marketing, articles: ['share-zone', 'saloncare-eshop'] },
  'share-zone': { video: null, articles: ['share-zone'] },
  marketinglist: { video: VIDEOS.marketing, articles: ['saloncare-eshop'] },

  digitalacademy: { video: VIDEOS.academy, articles: ['digital-academy'] },
  digitalcourse: { video: VIDEOS.academy, articles: ['digital-academy'] },
  digitalchapter: { video: VIDEOS.academy, articles: ['digital-academy'] },
  digitalexam: { video: VIDEOS.academy, articles: ['digital-academy'] },
  academy: { video: null, articles: ['academy-sessions'] },

  sav: { video: VIDEOS.sav, articles: ['creer-un-ticket-sav', 'suivre-un-ticket-sav'] },
  ticket: { video: VIDEOS.sav, articles: ['suivre-un-ticket-sav'] },
  assistance: { video: VIDEOS.sav, articles: ['creer-un-ticket-sav', 'demande-de-reparation'] },
  repair: { video: null, articles: ['demande-de-reparation'] },

  wallet: { video: null, articles: ['wallet'] },
  commissions: { video: null, articles: ['commissions'] },
  documents: { video: null, articles: ['factures-et-documents'] },
  company: { video: null, articles: ['mes-coordonnees', 'tour-de-lapplication'] },
  address: { video: null, articles: ['mes-coordonnees'] }
};

/** Aide de l'écran courant. Une route inconnue reçoit l'aide générique. */
export function helpForRoute(routeName) {
  return HELP_MAP[routeName] || { video: null, articles: ['tour-de-lapplication'] };
}

export default HELP_MAP;
